import { GuillochePattern } from "@shared/components/Brand/GuillochePattern";
import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

import { PerksHero } from "./components/PerksHero";
import { PerksList } from "./components/PerksList";

/**
 * @version 1.0.0
 * @published 2026-04-08
 * @history
 *   1.0.0 — Initial publish from prototype/pages/Perks/PerksPage.tsx. Landing
 *           page for the Perks loyalty program: navigation bar, a 60/40 split
 *           with an animated ember-blocks hero on the left and the ways-to-
 *           earn list on the right.
 */
export function PerksPage(): React.ReactElement {
    return (
        <main className="flex-1 flex bg-surface-ground overflow-hidden">
            {/* Left container — 60% */}
            <div className="w-[60%] relative overflow-hidden">
                {/* Guilloche pattern — uses public asset (shared across prototypes) */}
                <GuillochePattern src="/img/guilloche-2-new.svg" />

                {/* Hero — centered */}
                <div className="absolute inset-0 flex items-center justify-center z-10">
                    <PerksHero />
                </div>
            </div>

            {/* Right container — 40% */}
            <div className="w-[40%] border-l border-line-base flex flex-col items-center justify-center relative">
                <PerksList width="w-[340px]" />

                {/* Footnote */}
                <Text
                    variant="fine-print"
                    className="absolute bottom-6 right-6 text-foreground-imprint"
                >
                    <sup className="text-[8px]">1</sup> Global boost, applies on
                    top of all points you earn.
                </Text>
            </div>
        </main>
    );
}
